<template>
  <div class="main-container bg-grey-lightest">
    <div class="main-content-wrap">
      <div class="main-content-pannel" v-if="consultant">
        <div
          class="option-wrap bg-grey-lightest grey-bg-option no-border"
          style="height: 100px"
        >
          <div class="options">
            <div class="breadcrumb">
              <a href="javascript:void(0);" class="cursor-default"></a>
            </div>
            <div class="content-title-wrap p-t-0">
              <div class="main-content-title">
                {{
                  (consultant.name ? consultant.name : consultant.email)
                    | getNameByEmail
                }}'s Overview
              </div>
            </div>
          </div>
        </div>
        <div class="main-bg p-0 m-t-0 m-b-l">
          <div class="pannel-1">
            <div class="flex">
              <div class="flex-3">
                <div class="dashboard-statistics flex">
                  <div>
                    <h6>
                      Billing Amount
                      <i
                        class="material-icons align-middle"
                        style="font-size: 20px"
                        >arrow_drop_down</i
                      >
                    </h6>
                    <p>{{ amountEarned | currencyFilter("$", 2) }}</p>
                  </div>
                  <div>
                    <h6>
                      Hours Total
                      <i
                        class="material-icons align-middle"
                        style="font-size: 20px"
                        >arrow_drop_down</i
                      >
                    </h6>
                    <p class="font-color-lighter">{{ monthHours }}</p>
                  </div>
                </div>
                <div class="dashboard-calendar">
                  <Calendar
                    style="width: 100%"
                    :index="'techDashboard'"
                    :data="calendarData"
                    :key="calendarKey"
                    v-on:dateChange="updateCalendarBoard"
                  ></Calendar>
                </div>
              </div>
              <div
                class="flex-2"
                style="
                  max-width: 446px;
                  border-left: 1px solid var(--border-grey-lightest);
                "
              >
                <h3
                  class="flex items-center p-b-2l"
                  style="
                    margin-left: 15px;
                    margin-right: 15px;
                    border-bottom: 1px solid var(--border-grey-lightest);
                  "
                >
                  <div class="client-tech-resume-info-avatar flex m-r">
                    <div
                      class="
                        client-tech-resume-info-avatar-container
                        rounded-full
                      "
                    >
                      <span v-if="!consultant.photo_url">{{
                        (consultant.name ? consultant.name : consultant.email)
                          | getFirstLetter
                      }}</span>
                      <img v-else :src="consultant.photo_url" alt />
                    </div>
                  </div>
                  <div class="flex-1" style="font-size: 36px">
                    {{ consultant.name }}

                    <i
                      class="material-icons align-middle font-color-lighter"
                      v-if="
                        (consultant.client_confirm ||
                          consultant.reply === 'yes') &&
                        !(
                          consultant.client_confirm &&
                          consultant.reply === 'yes'
                        )
                      "
                      >check</i
                    >
                    <i
                      class="material-icons align-middle font-color-lighter"
                      v-if="
                        consultant.client_confirm && consultant.reply === 'yes'
                      "
                      >done_all</i
                    >
                    <i
                      class="material-icons align-middle font-color-green"
                      v-if="consultant.verified"
                      >verified</i
                    >
                  </div>
                </h3>
                <div class="dashboard-more-info">
                  <label
                    ><i class="material-icons align-middle">mail</i>
                    Email:</label
                  >
                  <p>{{ consultant.email ? consultant.email : "none" }}</p>
                  <label
                    ><i class="material-icons align-middle">phone</i> Phone
                    Number:</label
                  >
                  <p>
                    {{
                      consultant.phone_number ? consultant.phone_number : "none"
                    }}
                  </p>
                  <!--                    <label><i class="material-icons align-middle">mail</i> Title:</label>-->
                  <!--                    <p>{{ consultant.title ? consultant.title : "none" }}</p>-->
                  <label
                    ><i class="material-icons align-middle">location_city</i>
                    Metro:</label
                  >
                  <p>{{ consultant.metro ? consultant.metro : "none" }}</p>
                  <label
                    ><i class="material-icons align-middle">sticky_note_2</i>
                    Address:</label
                  >
                  <p>{{ consultant.address ? consultant.address : "none" }}</p>
                  <label
                    ><i class="material-icons align-middle">rate_review</i>
                    Rate:</label
                  >
                  <p>
                    {{
                      consultant.rate
                        ? consultant.rate
                        : 0 | currencyFilter("$", 2)
                    }}
                  </p>
                  <!--                    <label>Bio:</label>-->
                  <!--                    <p>{{ consultant.bio ? consultant.bio : "none" }}</p>-->
                  <!--                    <div v-if="consultant.interview_url">-->
                  <!--                      <label>Interview:</label>-->
                  <!--                      <a :href="consultant.interview_url">link</a>-->
                  <!--                    </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="main-bg p-0 m-t-0 m-b-0">
          <div class="pannel-1">
            <div class="pannel-1-title p-t-l">
              <h3 class="flex justify-content-between" style="width: 100%">
                Work log
                <div class="pannel-1-title-option">
                  <a
                    v-if="
                      user.roles && (user.roles.consultant || user.roles.admin)
                    "
                    class="btn primary"
                    href="javascript:void(0)"
                    @click="addTimeSheet()"
                  >
                    <i class="material-icons-outlined align-middle">add</i>
                    TimeSheet
                  </a>
                  <a
                    v-if="user.roles && user.roles.admin"
                    class="btn primary m-l"
                    href="javascript:void(0)"
                    @click="addCheckin()"
                    :class="{ active: editOpen == 2 }"
                  >
                    <i class="material-icons-outlined align-middle">add</i>
                    Add Record
                  </a>
                </div>
              </h3>
            </div>
            <div class="pannel-1-body">
              <ag-grid-vue
                style="width: 100%; height: 300px"
                class="ag-theme-material"
                :gridOptions="gridOptions"
                :columnDefs="columnDefs"
                @column-resized="onColumnResized"
                :rowData="rowData"
              ></ag-grid-vue>
            </div>
          </div>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelDashboardProfile
            v-if="editOpen == 1"
            :propsData="profileData"
            :submitLoading="profileSubmitLoading"
            @buttonClick="profileButtonClick"
          ></PanelDashboardProfile>
          <PanelDashboardCheckin
            v-if="editOpen == 2 || editOpen == 3"
            :propsData="checkinData"
            :companyOptions="companyOptions"
            :projectOptions="projectOptions"
            :submitLoading="checkinSubmitLoading"
            @buttonClick="checkinButtonClick"
          ></PanelDashboardCheckin>
        </edit-pannel>
      </transition>
    </div>
    <TimeSheet
      :dialogVisible.sync="TimeSheetVisible"
      :jobs="jobs"
      :projectOptions="projectOptions"
      :consultant="consultant"
    ></TimeSheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import { db } from "@/vendor/firebase";
import EditPannel from "@/components/EditPannel.vue";
import * as utils from "@/utils/utils";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import Calendar from "@/components/public/Calendar.vue";
import PanelDashboardProfile from "@/components/consultant/consultantDashboard/PanelDashboardProfile.vue";
import PanelDashboardCheckin from "@/components/consultant/consultantDashboard/PanelDashboardCheckin.vue";
import GridActions from "@/components/consultant/consultantDashboard/GridActions.vue";
import TimeSheet from "@/components/consultant/consultantDashboard/TimeSheet.vue";
import { getDocs } from "@/vendor/database";

export default {
  data() {
    return {
      queryId: null,
      consultant: null,
      jobs: null,
      jobApproves: null,
      companies: null,
      companyToName: {},
      companyOptions: [],
      assignedConsultants: null,
      projectOptions: [],

      editOpen: false,

      gridOptions: {},
      columnDefs: null,
      rowData: null,

      calendarData: {},
      calendarKey: 0,
      nextPayrollDate: moment()
        .tz("America/Los_Angeles")
        .startOf("month")
        .add(1, "month")
        .format("MM/DD/YYYY"),
      monthHours: 0,
      amountEarned: 0,

      profileData: null,
      checkinData: null,
      TimeSheetVisible: false,

      profileSubmitLoading: false,
      checkinSubmitLoading: false,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  components: {
    EditPannel,
    Calendar,
    AgGridVue,
    PanelDashboardProfile,
    PanelDashboardCheckin,
    GridActions,
    TimeSheet,
  },
  watch: {
    consultant: function () {
      const email = this.consultant.email;
      if (email) {
        this.$bind(
          "jobs",
          db.collection("jobs").where("consultant", "==", email)
        );
      } else {
        this.jobs = [];
      }
    },
    jobApproves: function () {
      this.updateJobs();
      this.updateWorkLogAndCalendar();
    },
    jobs: function () {
      this.updateJobs();
      this.updateWorkLogAndCalendar();
    },
    companies: function () {
      this.updateCompanies();
    },
    assignedConsultants: function () {
      this.updateAssignedConsultants();
    },
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    if (this.queryId) {
      this.initColumnDefs();
      this.bindData();
    } else {
      this.$router.push("/home/no_account").catch((err) => {});
    }
  },
  methods: {
    openAvatarCrop(email) {
      this.$store.commit("setImagecropperEmail", email);
      this.$store.commit("setImagecropperShow", true);
    },
    addTimeSheet() {
      this.TimeSheetVisible = true;
    },
    // openAvatarCrop() {
    //   this.$store.commit("setImagecropperShow", true);
    // },
    initColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.columnDefs = [
        {
          headerName: "CHECKIN",
          field: "checkin",
          comparator: utils.dateComparator,
          sort: "desc",
          sortingOrder: ["desc", "asc"],
        },
        {
          headerName: "CHECKOUT",
          field: "checkout",
        },
        { headerName: "CLIENT", field: "channel" },
        { headerName: "COMPANY", field: "companyName" },
        { headerName: "SUMMARY", field: "summary", cellClass: "word-wrap" },
        { headerName: "HOURS", field: "hours" },
        {
          headerName: "ACTIONS",
          field: "actions",
          width: 180,
          cellClass: "overflow-visible",
          cellRendererFramework: "GridActions",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    bindData: function () {
      if (this.queryId) {
        this.$bind(
          "consultant",
          db.collection("consultants").doc(this.queryId)
        );
        this.$bind("companies", db.collection("companies"));
        this.$bind("jobApproves", db.collection("job_approves"));
        this.$bind(
          "assignedConsultants",
          db
            .collection("assigned_consultants")
            .where("consultant_id", "==", this.queryId)
        );
      }
    },
    updateCompanies: function () {
      this.companyToName = {};
      this.companyOptions = [];
      this.companies.forEach((item) => {
        this.companyToName[item.id] = item.name;
        this.companyOptions.push({
          text: item.name,
          value: item.id,
        });
      });
    },
    updateAssignedConsultants: function () {
      this.projectOptions = [];
      const projectIds = this.assignedConsultants.map(
        (item) => item.project_id
      );
      getDocs("gigs", projectIds).then((result) => {
        (result || []).forEach((item) => {
          if (item.ok) {
            this.projectOptions.push({
              ...item.data.data,
              value: item.data.id,
              text: item.data.data.title,
            });
          }
        });
      });
    },
    updateWorkLogAndCalendar: function () {
      if (this.jobs && this.consultant) {
        const rowData = [];
        const calendarData = {};
        this.jobs.forEach((item) => {
          // if (item.work_type !== "timesheet" || item.approve) {
          const hours = utils.workHours(
            item.check_out - item.check_in,
            item.work_type
          );
          rowData.push({
            id: item.id,
            checkin: utils.dateformat(item.check_in, "MM/DD/YYYY HH:mm A"),
            checkout: utils.dateformat(item.check_out, "MM/DD/YYYY HH:mm A"),
            company: item.company,
            companyName: this.companyToName[item.company]
              ? this.companyToName[item.company]
              : item.company,
            channel: item.channel_id,
            summary: item.summary,
            workType: item.work_type,
            hours,
            projectId: item.project_id,
          });
          const calendarIndex = utils.dateformat(item.check_in, "YYYYMMDD");
          if (calendarData["i_" + calendarIndex]) {
            calendarData["i_" + calendarIndex] = {
              hours: calendarData["i_" + calendarIndex].hours + hours,
              isHistory: true,
            };
          } else {
            calendarData["i_" + calendarIndex] = {
              hours: hours,
              isHistory: true,
            };
          }
          // }
        });
        this.rowData = rowData;
        this.calendarData = calendarData;
        this.calendarKey++;
        this.updateCalendarBoard(
          moment().tz("America/Los_Angeles").startOf("month").valueOf()
        );
      }
    },
    updateCalendarBoard: function (ts) {
      if (this.jobs && this.consultant) {
        const startTimestamp = ts / 1000;
        const endTimestamp =
          moment(ts).tz("America/Los_Angeles").endOf("month").valueOf() / 1000;
        this.nextPayrollDate = moment(ts)
          .tz("America/Los_Angeles")
          .endOf("month")
          .format("MM/DD/YYYY");
        let monthHours = 0;
        let amountEarned = 0;
        this.jobs.forEach((item) => {
          if (
            item.check_in >= startTimestamp &&
            item.check_in <= endTimestamp
          ) {
            const hours = utils.workHours(
              item.check_out - item.check_in,
              item.work_type
            );
            // console.log(hours);
            monthHours += hours;
            const amount = hours * utils.toNumber(this.consultant.rate);
            amountEarned += amount;
          }
        });
        this.monthHours = monthHours;
        this.amountEarned = amountEarned;
      }
    },
    openEditPanel: function (action, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
    },
    closeEditPanel: function () {
      this.editOpen = false;
    },
    editProfile: function () {
      this.profileData = this.consultant;
      this.profileSubmitLoading = false;
      this.openEditPanel(1, true);
    },
    profileButtonClick: function (data) {
      // console.log(this.consultant.id, data)
      if (this.consultant && this.consultant.id) {
        this.profileSubmitLoading = true;
        db.collection("consultants")
          .doc(this.consultant.id)
          .update(data)
          .then(() => {
            this.closeEditPanel();
            this.$toasted.global.toast_success({ message: "edit success" });
          })
          .catch(() => {
            this.$toasted.global.toast_error({ message: "edit error" });
          })
          .finally(() => {
            this.profileSubmitLoading = false;
          });
      } else {
        this.$toasted.global.toast_error({ message: "edit error" });
      }
    },
    addCheckin: function () {
      this.checkinData = {};
      this.openEditPanel(2, true);
    },
    editCheckin: function (data) {
      this.checkinData = data;
      this.openEditPanel(3, true);
    },
    deleteCheckin: function (data) {
      utils.deleteConfirm(() => {
        db.collection("jobs")
          .doc(data.id)
          .delete()
          .then(() => {
            this.$toasted.global.toast_success({ message: "delete success" });
          })
          .catch(() => {
            this.$toasted.global.toast_error({ message: "delete error" });
          });
      });
    },
    checkinButtonClick: function (data, id) {
      if (
        data &&
        data.check_in &&
        data.check_out &&
        // data.channel_id &&
        // data.work_type &&
        // data.summary &&
        this.consultant &&
        this.consultant.email
      ) {
        data.consultant = this.consultant.email;
        if (id) {
          this.checkinSubmitLoading = true;
          db.collection("jobs")
            .doc(id)
            .update(data)
            .then(() => {
              this.closeEditPanel();
              this.$toasted.global.toast_success({ message: "edit success" });
            })
            .catch(() => {
              this.$toasted.global.toast_error({ message: "edit error" });
            })
            .finally(() => {
              this.checkinSubmitLoading = false;
            });
        } else {
          this.checkinSubmitLoading = true;
          db.collection("jobs")
            .add(data)
            .then(() => {
              this.closeEditPanel();
              this.$toasted.global.toast_success({ message: "add success" });
            })
            .catch(() => {
              this.$toasted.global.toast_error({ message: "add error" });
            })
            .finally(() => {
              this.checkinSubmitLoading = false;
            });
        }
      } else {
        this.$toasted.global.toast_error({ message: "params error" });
      }
    },
    updateJobs: function () {
      if (this.jobs) {
        if (this.jobApproves) {
          const jobApprovesObj = {};
          this.jobApproves.forEach((item) => {
            jobApprovesObj[item.id] = item.approve;
          });
          this.jobs.forEach((item) => {
            if (item.id in jobApprovesObj) {
              item.approve = jobApprovesObj[item.id];
            }
          });
        }
      }
    },
  },
};
</script>
